<script>
  import BlueChip from "./base/BlueChip.svelte";
  import { translate } from "../../i18n/i18next.js";
</script>

<BlueChip title={translate("mySchedule.plans.viewer.name")} />